import { platformContext } from "shared";
import cn from 'classnames';
import { useLocation } from "react-router-dom";
import { Platform } from "@yandex-int/hr-components/lib";
import React, { PropsWithChildren, useContext, useMemo } from "react";
import styles from './page-content.module.scss';

export const PageContent: React.FC<
    PropsWithChildren & { className?: string, wrapperClassName?: string }
> = ({ wrapperClassName = 'contentWrapper', children, className }) => {
    const platform = useContext(platformContext);
    const location = useLocation();
    const isIframe = useMemo(() => {
        const path = location.pathname.split("/");
        return path[1] === "iframe";
    }, [location.pathname]);

    return (
        <div className={cn(styles[wrapperClassName], platform === Platform.DESKTOP && !isIframe ? styles.contentWrapperDesktop : "")}>
            <div className={cn(styles.content, className)}>{children}</div>
        </div>
    );
};
